var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLess3Heart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 48,
    viewBox: "0 0 63 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.7559,
    y: 0.500488,
    width: 22.0426,
    height: 44.0853,
    transform: "rotate(45 46.7559 0.500488)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5859,
    y: 0.500488,
    width: 33.064,
    height: 22.0426,
    transform: "rotate(45 15.5859 0.500488)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess3Heart);
export default __webpack_public_path__ + "static/media/Less3Heart.5a15c68b319941f7986a54464d6f3272.svg";
export { ForwardRef as ReactComponent };